import Canonical from "@/components/Canonical";
import dynamic from "next/dynamic";
const Layout = dynamic(() => import("@/lib/Layout/Layout"));
const SignupCard = dynamic(() => import("@/components/Authentication/SignupCard"));
import { footerData } from "./api/footerData";
//import useAuthStore from "@/lib/store/useAuthStore";

const Signup = () => {
  // const { otplessUserData } = useAuthStore((state) => state);
  // console.log(".....OTPLESSUSERDATA..... : ", otplessUserData)
  return <>
    <Layout footerData={footerData}>
      <Canonical/>
      <SignupCard />
    </Layout >
  </>
};

export default Signup;
